export default {
  ActionConfirm: "Подтвердите действие",
  ActivatePromocode: "Активировать промокод",
  AddFile: "Додати файл",
  AddToFavorites: "Добавить в избранное",
  "Andar Bahar": "Andar Bahar",
  ApplyFilter: "Применить фильтр",
  AppsPage: {
    blocks: {
      descriptionOne: "Не нужно искать актуальные зеркала",
      descriptionThree: "Персональные уведомления о всех акциях, турнирах и розыгрышах",
      descriptionTwo: "Уникальные акции и предложения для пользователей приложений",
      titleOne: "ОЛИМП всегда под рукой",
      titleThree: "Будьте в курсе всех событий и предложений",
      titleTwo: "Эксклюзивные акции и турниры"
    },
    dontWorry: "Не переживайте, это безопасно",
    howToInstall: "Как установить",
    installAndroid: "Скачать для Андроид",
    installIos: "Установить для iOS",
    installIsSafe: "Установка безопасна",
    qrText: "Наведите камеру на QR-код, чтобы скачать приложение",
    safeDescription: " Мы не можем выложить приложение в Play Market из-за политики Google в отношении азартных игр. Для установки, следуйте инструкции",
    seo: {
      all: {
        block_one: {
          description: "{platform} — это современная платформа для виртуального беттинга и гемблинга с большим ассортиментом развлечений. Мы уделяем особое внимание комфорту пользователей, именно поэтому нашу онлайн-площадку можно посетить с любого устройства — как с компьютера, так и со смартфона. Мобильное приложение казино Олимп адаптировано для всех современных телефонов, которые работают на базе популярных операционных систем — Android и iOS. Любители азартных игр могут использовать весь потенциал интернет платформы где угодно в удобное для них время.",
          title: "Мобильное приложение {platform}"
        },
        block_three: {
          description: "В распоряжении любого игрока, который скачал приложение и зарегистрировался в нём, — весь функционал площадки и полный набор инструментов. Что именно доступно в мобильном приложении? Через личный кабинет вы можете:",
          list: {
            five: "Изучать историю финансовых операций по игровому счёту — заказов на снятие средств, платежей и ставок.",
            four: "Использовать бонусы — welcome-пакет и другие подарки.",
            one: "Настраивать профиль — добавить номер телефона или адрес почты, заполнить информацию о себе и изменить её.",
            three: "Следить за рассылкой от казино в сообщениях.",
            two: "Проверять баланс, пополнять его любыми удобными способами, выводить призовые суммы и получать моментальный кешбэк."
          },
          text: "Играть онлайн в казино Олимп и делать ставки можно сразу после процедуры регистрации. Нужно лишь внести минимальный депозит и выбрать развлечение по душе — в нашем приложении представлены игровые автоматы, лотереи, быстрые, спортивные и классические игры, live-казино, ставки на спорт и различные турниры. Если у вас возникнут вопросы во время онлайн-сессии в приложении Olymp Casino, на помощь придёт техническая поддержка. Достаточно открыть чат и оставить сообщение в специальной форме.",
          title: "Функционал"
        },
        block_two: {
          description: "Магазины приложений — Google Play Market, AppGallery и другие маркеты — придерживаются разной политики в отношении азартных развлечений и не всегда размещают в своих каталогах необходимый софт. Мы упростили вам процесс поисков и разместили мобильное приложение казино Олимп для всех ОС в открытом доступе — его легко скачать прямо с нашего официального сайта. Можно выбрать один из следующих алгоритмов действия:",
          list: {
            one: "Воспользоваться компьютером. Для этого запустите официальный портал {platform} через любой браузер или откройте через поисковую систему рабочее зеркало. Там вы найдёте страницу с кнопками «Установить для iOS»  и «Скачать для Андроид». Кликните на подходящий вариант и отсканируйте QR-код с помощью камеры телефона. На его экране отобразится ссылка — перейдите по ней. Если вы используете iPhone, вас перенаправит на наше приложение в App Store, откуда вы сможете его загрузить. Если у вас Android, нужно предоставить разрешение на установку приложения и дождаться её окончания.",
            two: " Воспользоваться мобильными устройствами. Зайдите на сайт {platformSite} — откроется мобильная версия сайта Олимп. Чтобы скачать приложение бесплатно, сначала выберете из двух кнопок для загрузки нужную в зависимости от ОС вашего смартфона. Не забудьте сперва заглянуть в «Настройки» телефона и разрешить установку неизвестных файлов — это безопасно. Приложение скачается за считанные минуты"
          },
          text: "Жмите «Вход» и приступайте к авторизации. Если вы ещё не обзавелись аккаунтом в {platform}, самое время это сделать. Введите в соответствующие поля номер телефона или e-mail, придумайте хороший пароль и подтвердите действие.",
          title: "Где скачать приложение"
        }
      },
      android: {
        block_four: {
          description: "Мобильное приложение {platform} работает на английском, казахском, узбекском, кыргызском и русском языке — можно сменить его в любой момент. Приложение адаптировано для использования через телефон с максимальным комфортом — все элементы интерфейса перенесены сюда с учётом размеров мобильных экранов. Каждому авторизованному владельцу смартфона доступны все функции десктопной версии сайта:",
          list: {
            five: "Личные сообщения.",
            four: "История платежей, ставок и заказов на вывод средств.",
            one: "Настройки профиля.",
            three: "Промокоды и подарки — фриспины, бесплатные ставки и бонусы на депозит.",
            two: "Операции с игровым счётом — пополнение, вывод и моментальный кешбэк."
          },
          text: "И главное — через телефон или планшет вы сможете опробовать любые игры, которые вас заинтересовали, испытать удачу в ставках на спорт и поучаствовать в акциях и турнирах. Казино Олимп всегда будет у вас под рукой, а благодаря персональным уведомлениям вы не пропустите эксклюзивные предложения.",
          title: "Функционал"
        },
        block_one: {
          description: "В {platform} собрана богатая коллекция азартных развлечений для всех, кто предпочитает отдыхать с удовольствием независимо от места нахождения. Ставки на спорт и лотереи, быстрые и бет игры, live-казино и слоты — игровой софт доступен вам прямо с телефона! Владельцы смартфонов на базе операционной системы Андроид могут позволить себе всё — специально для вас мы разработали специальное мобильное приложение Олимп на Андроид. Пополняйте личный счёт через телефон или планшет, запускайте онлайн любимые игровые автоматы и слоты и наслаждайтесь процессом.",
          title: "Приложение для Android Олимп Казино"
        },
        block_three: {
          description: "Собираетесь скачать бесплатно приложение Олимп на Android с официального сайта? Нужно подготовить мобильное устройство к установке APK-файлов. Для начала включите необходимые разрешения:",
          list: {
            four: "При появлении на экране запроса «Разрешить установку из этого источника» нажмите кнопку, чтобы начать скачивание.",
            one: "Перейдите к «Настройкам» на смартфоне и найдите пункт «Приложения».",
            three: "Обеспечьте доступ для установки неизвестных приложений.",
            two: "Откройте меню «Разрешения»."
          },
          text: "Скачать приложение Олимп на Андроид через десктопную версию портала можно с помощью QR-кода. Он появится прямо на странице — вам останется только навести камеру смартфона на код и дождаться ссылки для загрузки. С мобильной версией Olymp Casino процесс установки сводится к нескольким простым действиям. Чтобы загрузить приложение через смартфон, откройте в браузере мобильную версию портала. Там вы увидите кнопку «Скачать приложение». Перейдите по ней — и перед вами появится надпись «Загрузить». Смело жмите на ссылки для установки — это безопасно, файл скачается из надёжного источника. Готово! Можно наслаждаться всеми преимуществами мобильного приложения. Теперь вы избавлены от необходимости искать рабочие зеркала или устанавливать VPN — мобильное приложение Olymp Casino будет работать, пока у вас есть выход в Интернет. Если данное приложение потребует обновления до последней версии, сделайте это, чтобы всё работало исправно.",
          title: "Инструкция по установке"
        },
        block_two: {
          description: "Мобильное приложение {platform} для Android — ваш проводник в мир лучших азартных игр и спортивных ставок. Где его скачать? В мобильных маркетах для Андроид — например, в Google Play Market, AppGallery или любом другом похожем магазине приложений — действуют особая политика в отношении азартных игр. Там можно встретить только проекты от сторонних разработчиков. С официальным сайтом Olymp Casino они никак не связаны. Чтобы найти наше оригинальное приложение, нужно открыть главный сайт olymp.casino на компьютере или на мобильном устройстве.",
          title: "Где скачать приложение"
        }
      },
      ios: {
        block_one: {
          description: "Среди владельцев iPhone и iPad много поклонников азартных игр {platform}. Наше мобильное приложение для устройств на базе операционной системы iOS открывает перед пользователями широкие возможности и предоставляет полную свободу действий. В любое время у вас в кармане — огромный каталог развлечений с полным функционалом интернет-казино. Вносите средства на счёт, управляйте данными профиля, обналичивайте призовые суммы любых размеров, играйте в режиме онлайн и пробуйте новое каждый день. Мобильное приложение казино Олимп для iOS поможет вам получить столько удовольствия и извлечь столько выгоды, сколько вы сами хотите! Для этого нужно правильно «оснастить» свой телефон или планшет и перейти к развлечениям.",
          title: "iOS приложение Олимп Казино для iPhone"
        },
        block_three: {
          description: "Приложение казино Олимп для устройств на базе iOS открывает вам полный доступ ко всей коллекции азартных развлечений платформы — многочисленным слотам, настольным, спортивным и краш-играм, столам, лотереям, акциям, турнирам. Через личный кабинет в мобильном приложении можно выполнить любые необходимые действия:",
          list: {
            five: "Просмотреть историю операций — всех заказов на вывод денег, транзакций и ставок.",
            four: "Прочитать сообщения от казино.",
            one: "Изменить персональные сведения в профиле и пройти верификацию.",
            three: "Получить, активировать и отыграть подарки — в том числе welcome-бонус для новичков.",
            two: "Пополнить счёт, обналичить выигрыш и получить моментальный кешбэк."
          },
          text: "Специально для пользователей мобильного приложения предусмотрено множество уникальных предложений: не забудьте включить уведомления, чтобы оставаться в курсе всех событий и своевременно узнавать о выгодных акциях, актуальных розыгрышах и эксклюзивных турнирах. Пора пополнять депозит, делать ставки, «тестировать» игровые автоматы и прокачивать удачу. Мы позаботились о том, чтобы каждая виртуальная сессия в приложении казино Olymp доставляла вам только приятные впечатления.",
          title: "Функционал и возможности"
        },
        block_two: {
          description: "  Мы знаем, как эффективно и с комфортом для пользователей обеспечить их необходимым инструментом для игры. Мобильное приложение {platform} есть в фирменном магазине Apple — оно бесплатное. Чтобы загрузить официальное приложение Олимп для iOS, нужно получить ссылку на его скачивание из магазина App Store. Есть два способа это сделать – выбрать можно тот, что удобнее:",
          list: {
            one: "Запустите официальный сайт казино Олимп на компьютере и перейдите на страницу со ссылкой на мобильное приложение. Там вы увидите QR-код — наведите на него камеру вашего устройства и нажмите на ссылку для скачивания.",
            two: "Зайдите на портал {platformSite} сразу через устройство на платформе iOS —откроется мобильная версия. Чтобы скачать приложение Олимп на iPhone или iPad таким образом, достаточно нажать на кнопку «Установить для iOS». Вас перенаправит в App Store — и вы сможете начать установку приложения."
          },
          text: "Когда скачивание завершится, можно создать аккаунт в системе или авторизоваться, если у вас уже есть личный кабинет, и приступить к самому интересному — развлечениям {platform}!",
          title: "Установить приложение легко"
        }
      }
    },
    seoText: " Особый сеошный текст может и не понадобится на странице для айфонов, но можно попробовать написать обзор на приложение и оптимизироваться под семантику категории “обзор приложения олимпбет”. И там и там почти нет частотки.",
    seoTitle: "SEO text",
    slider: {
      textEight: "Нажмите на кнопку «Скачать приложение» на сайте",
      textFive: "Нажмите на кнопку «Установить»",
      textFour: "Нажмите на скачанный файл приложения",
      textOne: "Нажмите на кнопку «Загрузить», чтобы начать скачивание",
      textSeven: "Наведите камеру телефона на QR код и перейдите на сайт",
      textSix: "Запускаете приложение с рабочего стола и играете",
      textThree: "Разрешите установку приложений из неизвестных источников",
      textTwo: "Зайдите в раздел «Установка неизвестных приложений»"
    },
    slides: {
      allowInstall: "Разрешить установку из неизвестных источников",
      cancel: "Отмена",
      download: "Загрузить",
      downloadApp: "Скачать Приложение",
      downloadIsDone: "Загрузка завершена",
      installUnknownApp: "Установка неизвестных приложений",
      isntall: "Установить",
      moveToSite: "Перейти на сайт",
      myFiles: "Мои файлы",
      safeDescription: " Установка приложений не из Play Market. Загружайте файл только из надежного источника",
      settings: "Настройки"
    },
    textForMobile: {
      androidAndIos: "на Андроид и iOS",
      downloadOnAndroid: "Скачать на Андроид",
      downloadOnAndroidAndIos: "Скачать на Андроид и iOS",
      downloadOnIos: "Скачать на iOS",
      onAndroid: "на Андроид",
      onIos: "на iOS"
    },
    title: "Приложение Олимп"
  },
  Aviator: "Aviator",
  Basket: "Корзина",
  BeforeEndPromotion: "До окончания акции",
  BeforeStartPromotion: "До начала акции",
  Betgames: "Betgames",
  Bets: "Cтавки",
  BonusBalanceOff: "Ви перейшли на основний баланс казино. Поповніть рахунок та грайте у улюблені ігри.",
  BonusBalanceOn: "Ви перейшли на бонусний баланс.",
  BonusesAndPromotions: "Бонусы и акции",
  BonusesAndPromotionsSection: "Раздел бонусов и акций",
  Categories: "Категории",
  Chat: "Чат",
  CloseMatchTracker: "Закрыть матч-трекер",
  CoefficientChanged: "Изменился коэффициент",
  ContactSupport: "Обратитесь в поддержку",
  "Cricket X": "Cricket X",
  DeleteConfirm: "Подтверждение удаления",
  DeleteConfirmText: "Вы действительно хотите удалить ранее загруженные файлы?",
  DeleteFiles: "Удалить файлы",
  DenyReason: "Отклонено по причине",
  DocumentAlreadyAttached: "Данный файл уже прикреплен",
  DocumentDoesntMeetRequirements: "Документ не соответствует требованиям",
  DocumentResolutionTooBig: "Слишком большое разрешение фотографии. Максимально допустимое - {value} Мп",
  DocumentsFilesLimits: "(макс. кол-во файлов - {fields}, макс. размер файла - {size} Мб)",
  DocumentsUploadError: "Произошла ошибка во время загрузки файлов - {files}. Остальные файлы были отправлены на проверку. Вы можете попробовать загрузить эти файлы повторно",
  DownloadOn: "Скачать на",
  EuroLanding: {
    activate: "<span>Активируйте</span><br /> в разделе «Бонусы»",
    bonusText: "<span>Фрибет</span><b>{freebet}</b><span>за регистрацию!</span>",
    register: "<span>Регистрируйтесь</span><br /> на сайте Olymp Casino"
  },
  Event: "Событие",
  Exclusive: "Exclusive",
  Expires: "Истекает",
  ForbidenBonus: "Призы за текущий день уже были получены",
  Found: "Найдено",
  FruityWheel: {
    btn: "Крути",
    title: "Крути и узнай свой welcome бонус"
  },
  GatesOfOlympus: {
    completeSignIn: "Завершите регистрацию сейчас и получите бонус",
    getBonus: "Забрать бонус",
    spin: "Крути",
    titleFirstLine: "Крути колесо",
    titleSecondLine: "получай бонусы",
    twist: "Крутить",
    youWin: "Вы выиграли",
    yourBonus: "Ваш бонус"
  },
  GetYourPrizes: "Забирай призы",
  GoldenTimesKz: {
    bonusText: "Поздравляем! Твой выигрыш",
    headTitle: "Забирай свой бонус<br />и срывай джекпот!",
    labelText: "Введите номер своего телефона"
  },
  InformationAllPromotions: "Информация по всем акциям",
  InitialCoefficient: "Исходный коэф.:",
  JetX: "JetX",
  LongTermRates: "Долгосрочные ставки",
  MainSite: "Основной сайт",
  MatchTracker: "Матч-трекер",
  MaximizeMatchTracker: "Увеличить матч-трекер",
  MinimizeMatchTracker: "Уменьшить матч-трекер",
  Mobile: "Мобильная",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "Выберите пункт меню /app",
    getLink: "или получи ссылку в Telegram боте",
    getLinkButton: "Получить ссылку",
    groups: {
      four: "Будьте в курсе всех <br/> событий и предложений",
      one: "<span>100 FS без депозита</span>за установку приложения",
      three: "Эксклюзивные <br/> акции и турниры",
      two: "Не нужно искать <br/> актуальные зеркала"
    },
    start: "/start",
    startText: "Запустите Telegram бота нажав /start",
    successLink: "Ссылка успешно отправлена",
    text: "Скачивай мобильное приложение Olymp и будь готов к игре в любой момент",
    title: "<span>100 FS без <br/> депозита </span> за установку OLYMP"
  },
  MobileApplications: "Мобильные приложения",
  MyDocuments: "Мои документы",
  NewYearRules: {
    "1": "Период проведения акции: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +3",
    "10": "Фрибеты Aviator",
    "11": "Фрибеты JetX",
    "12": "В случае выигрыша бонуса на промо странице, бонус добавляется в личный кабинет, раздел “Бонусы”, путем нажатия на кнопку “Перейти к бонусу”",
    "13": "Активация добавленных бонусов доступна в течение 3 дней",
    "14": "После активации депозит необходимо внести в течение 1 дня",
    "15": "Отыгрыш бонусных средств необходимо совершить в течение 1 дня",
    "16": "Подробные условия по каждому бонусу доступны на странице “Бонусы” в личном кабинете",
    "2": "Каждый день на промо странице дается 3 попытки для получения бонуса",
    "3": "Количество попыток обнуляются до 3 каждый день в течение срока действия акции в 00:00 GMT +3",
    "4": "Чтобы выиграть бонус, пользователь должен заходить каждый день на промо страницу и запускать слотмашину путем нажатия на кнопку SPIN",
    "5": "Каждое нажатие на SPIN забирает одну попытку",
    "6": "Выигрыш бонуса и тип бонуса определяется случайным образом из:",
    "7": "Бонус на депозит в слотах",
    "8": "Фриспины в слотах",
    "9": "Фрибеты на спорт"
  },
  NezlobLanding: {
    forDeposit: "на депозит",
    title: "Шутки кончились"
  },
  NotCalculated: "Не рассчитано",
  NotSingleActionCurrentlyHeld: "Ни одной акции сейчас не проводится",
  OlimpCasino: "Олімп казино",
  OpenFullVersion: "Открыть полную версию",
  PaymentMethods: "Способы оплаты",
  PlayEveryDay: "Играй каждый день",
  PromoAvailableFrom: "Акция доступна с {date} года",
  PromoAvailableFromTo: "Акция доступна с {date1} до {date2} года",
  PromoEnded: "Акция завершена {date} года",
  Promotions: "Акції",
  PromotionsWillDisplayedHere: "Здесь будут отображаться акции",
  QuestionAndAnswer: "Вопрос - Ответ",
  RulesAcceptingBets: "Правила прийому ставок букмекерської контори «Олімп»",
  RulesOfPromotion: "Правила акции",
  RulesSingle: "Правила",
  SelectTypeSystem: "Выберите тип системы",
  Soon: "Скоро",
  Statistics: "Статистика",
  StayTuned: "Оставайтесь с нами",
  TableContents: "Зміст",
  TheSearchHasNotGivenAnyResults: "Поиск не дал результатов",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "Для отключения необходимо подтвердить телефон и e-mail",
  ToMain: "На главную",
  ToUp: "Наверх",
  TypeBonusesAndPromotions: "Тип бонусов и акций",
  UntilTheNextBonus: "До следующего бонуса",
  UploadDocuments: "Загруженные файлы",
  Version: "версия",
  WeAreOnSocialMedia: "Мы в соц. сетях",
  WeOnSocialMediaFull: "Мы в социальных сетях",
  WorldCup: "ЧС-2022",
  YouDataProtected: "Личные данные и средства в безопасности",
  YourBonus: "Ваш бонус",
  aboutBonus: "Детальніше про бонус",
  acceptWithModifiedOdds: "Принимать с изменёнными коэффициентами",
  acceptWithModifiedTotals: "Принимать с измененными тоталами/форами",
  accountApprove: "Аккаунт защищен",
  accountNotApprove: "Аккаунт не защищен",
  action: "Дія",
  activate: "Активувати",
  activateBonus: "Активировать бонус",
  activateFastBets: "Активируйте быстрые ставки",
  activatingPromoCode: "Активация промокода",
  active: "Активный",
  activeBonusErr: "Для активації бонусу, залишилося зробити депозит на суму не менше",
  activeWager: "Активний вейджер",
  add: "Добавить",
  addToBasket: "Добавить в корзину",
  addYourFavoriteGames: "Добавляйте любимые игры в избранное с помощью",
  addingDogeCoin: "Добавляем монету Doge",
  additionalInfo: "Додаткова інформація",
  addressCryptoWallet: "Адрес криптокошелька",
  addressWallet: "Адрес кошелька",
  afterInstallApp: "Вы получили бонус {0} за установку приложения",
  agreeTermsAndConditions: "Я согласен с {0} и подтверждаю, что мне больше 18 лет",
  all: "Усі",
  allDepositMethods: "Все методы пополнения",
  allGames: "Всі ігри",
  allMessages: "Всього",
  allMessagesButton: "Перейти в сообщения",
  allMessagesText: "Всі повідомлення",
  allPromo: "Всі акції",
  allRequiredFieldsMustBeFilled: "Всі обов'язкові поля повинні бути заповнені",
  allTypes: "Все типы",
  allWithdrawMethods: "Все методы вывода",
  all_right: "Усі права захищені.",
  alreadyHasAccount: "Уже есть аккаунт",
  always: "Всегда",
  amountOnAccount: "Сумма на счету",
  anUnexpectedErrorOccurred: "Произошла непредвиденная ошибка!",
  antifraud: {
    five: "Багатоступенева перевірка клієнтів (Перевірка по IP, зняття параметрів системи, проксі перевірка); Перевірка телефонного номера клієнта; Аналіз поведінки гравця фахівцем; Система захисту від шахрайства має більш ніж 100 фільтрів, призначених для глибокої перевірки платежів, історії платежів і чорного списку користувачів; Клієнт проходить остаточну перевірку нашою контрольною службою на етапі виведення коштів.",
    four: "Основні характеристики",
    one: "Захист вiд шахрайства",
    three: "У співпраці з провідними постачальниками послуг інтернет-платежів, ми робимо все можливе, щоб вести онлайн бізнес надійно і гарантувати безпеку приватної інформації наших користувачів, а також всіх платежів. Наш десятирічний досвід управління базами даних платіжних транзакцій робить Avento AntiFraud Tool дійсно потужним і зручним засобом проти шахрайства з кредитними картами.",
    two: "Avento AntiFraud Tool є потужним інструментом для захисту від шахрайства, розробленим, щоб запобігти шахрайським операціям в онлайн-сфері азартних ігор. Що дозволяє нам значно знизити кількість шахрайства з кредитними картами в наших гральних закладах."
  },
  app: "Додаток",
  appOlymp: "Приложение Олимп",
  apply: "Застосувати",
  approve: "Підтверджую",
  approvePhoneBySms: "Подтвердить номер по СМС",
  approvePhoneByTelegram: "Подтвердить номер через Telegram",
  approved: "Одобрено",
  approvedSecond: "Подтверждено",
  approvingWithdraw: "Подтверждение вывода средств",
  april: "апреля",
  areYouSureDeposit: "Вы точно пополнили?",
  areYouSureToDeclineBonus: "Ви впевнені, що хочете відмовитися від бонусу?",
  areYouSureYouWantToSell: "Вы уверены что хотите продать ставку",
  attach: "Прикріпити документи",
  attachDocumentsToVerifyAccount: "Будь ласка, прикріпіть документи для завершення верифікації та виведення коштів",
  attempt: "Нет попыток | 1 Попытка | {count} Попытки",
  august: "августа",
  authApproveText: "Для проверки, что вы не робот, нажмите на кнопку 'Подтверждаю'",
  authFromSocial: "Вхід через соц. мережі",
  authorization: "Авторизація",
  authorizationRequired: "Платна гра потребує авторизації!",
  availabilityWallet: "Потрібен криптогаманець {wallet}",
  available: "Доступно",
  availableBonuses: "Доступні бонуси",
  availableOnlyGameForMoney: "Доступна тільки гра на гроші",
  back: "Назад",
  backToHome: "Повернутися на головну",
  backToLogin: "Повернутися до авторизації",
  backToOneStep: "Повернутися до першого кроку",
  balance: "Баланс",
  balanceAfterTopUp: "Баланс после пополнения: {value}",
  balanceAfterWithdraw: "Баланс после вывода: {value}",
  balanceBK: "Баланс БК",
  balanceBKRefreshSuccessfully: "Баланс БК успішно оновлений",
  balanceCasino: "Баланс казино",
  balanceCasinoRefreshSuccessfully: "Баланс казино успішно оновлено",
  balanceSwitchByWithoutBalance: "Переключение на бонусный баланс происходит автоматически только при игре в бонусные игры, если на реальном балансе отсутствуют средства",
  balances: "Баланси",
  bankCard: "Банковская карта",
  basketBets: "Корзина",
  behind: "за",
  bet: "Ставка",
  betHistory: "Історія ставок",
  betID: "ID ставки",
  betSoldFor: "Ставка продана за",
  betsAreSuspended: "Прием ставок приостановлен",
  betsNotAccessForBonusBalance: "Ставки на спорт не доступны с бонусного баланса!",
  bettingHistory: {
    bet: "Ставка",
    coefficient: "Коэффициент",
    dataOfBet: "Данные ставки",
    findOutTheScore: "Узнать счёт",
    numberAndDateOfBet: "Номер и дата ставки",
    payout: "Выплата",
    status: "Статус"
  },
  bidAddedToCart: "Ставка добавлена в корзину",
  bidDeletedToCart: "Ставка удалена из корзины",
  bonus: "Бонус",
  bonusActivated: "Бонус активований",
  bonusActivation: "Активация бонуса",
  bonusBalance: "Бонус. баланс",
  bonusBalanceOnly: "Для гри з бонусного балансу запустіть бонусну гру",
  bonusCondition: "Умови бонусу",
  bonusNotActivated: "Бонус не активований",
  bonusOnFirstDeposit: "Бонус 100 %<br/> на первый депозит",
  bonusQuestion: "Ви ще не отримали вітальний бонус?",
  bonusSport: {
    block1: {
      li1: "Зарегистрируйтесь на сайте olymp.casino.",
      li2: "Для активации бонуса перейдите в раздел «Бонусы» в Личном кабинете и активируйте предложение.",
      li3: "Внесите депозит от 500 KZT / 12 000 UZS одним платежом.",
      li4: "После пополнения бонус будет начислен автоматически и доступен для ставки в разделе «Спорт» в вашем купоне.",
      title: "Как получить свой бонус:"
    },
    block2: {
      li1: "Пользователь имеет право только на один бонус.",
      li2: "Бесплатную ставку можно использовать только на спорт. Ваш купон должен быть ординарной ставкой с коэффициентом не менее 3 и максимум 10.",
      li3: "Игрок получает на свой счет только выигрышную часть.",
      text: "Например: Бесплатная ставка 500 на коэффициент 3. Игрок получает на счет 3*500-500 = 1000.",
      title: "Условия и положения:"
    },
    block3: {
      li1: "Требования по отыгрышу бесплатной ставки должны быть выполнены в течение 7 дней, в противном случае срок действия бонуса истечет.",
      li10: "Olymp.casino имеет право изменить условия предложения, отменить или возобновить предложение, либо отказать в участии в любое время без предварительного уведомления.",
      li11: "Olymp.casino может ограничить или отказать пользователям в участии в этом или любом другом предложении.",
      li12: "Для одного клиента, семьи, адреса, общего компьютера, общего IP-адреса и любых идентичных данных учетной записи, включая адрес электронной почты,  реквизиты банковского счета, информацию о кредитной карте и счете платежной системы, допускается только один бонус. Любое злоупотребление этим бонусным предложением приведет к закрытию счета.",
      li13: "Olymp.casino оcтавляет за собой право в любое время изменить или отменить данное предложение.",
      li14: "Принимая бонус, клиент соглашается с бонусными условиями, а также с общими правилами и положениями Olymp.casino.",
      li2: "Для вывода выигрыша вам необходимо сделать минимальный депозит 500 KZT / 12 000 UZS и выполнить вейджер х1.",
      li3: "В случае отмены или возврата - ставка рассчитывается как проигрыш.",
      li4: "В случае полупроигрыш (азиатская фора и тотал) - ставка рассчитывается как проигрыш.",
      li5: "В случае полувыигрыш (азиатская фора и тотал) - рассчитывается как обычная ставка, исключая сумму ставки.",
      li6: "После расчета ставки деньги поступают на ваш баланс.",
      li7: "Бесплатная ставка не может быть использована частично. (т. е. если у вас есть бесплатная ставка на 500, вы должны сделать ставку на 500. 250 - 250 для разных купонов не принимаются).",
      li8: "Предложение не может быть использовано в сочетании с другими рекламными или специальными предложениями.",
      li9: "Использование нескольких учетных записей не допускается и в случае обнаружения нескольких учетных записей это приведет к приостановке всей учетной записи.",
      title: "Інші умови:"
    },
    title: "Лучшее время присоединиться к Olymp.Casino - сейчас, ведь мы предлагаем каждому новому пользователю бесплатную ставку на спорт 500 KZT / 12 000 UZS"
  },
  bonusTimeLeft: "До окончания увеличенного бонуса",
  bonusWager: "Вейджер бонусу:",
  bonuses: "Бонуси",
  bookmakerShort: "БК",
  "break": "Перерыв",
  bronze: "Бронза",
  btn: "Каса",
  byDefault: "По умолчанию",
  byDefaultDown: "По алфавиту (A-Z)",
  byDefaultUp: "По алфавиту (Z-A)",
  bySport: "По видам спорта",
  cabbage: {
    eight: "- якщо гравець завершив повний цикл з 5 днів.",
    eighteen: "Приз {number}",
    eleven: "Беручи участь в акції, ви автоматично погоджуєтеся з цими правилами і умовами, встановленими онлайн-казино, яке проводить цю акцію.",
    fifteen: "Цілі і призи",
    five: "Нагороди ростуть разом з щоденним прогресом і виконанням денних цілей. Щоб зберегти щоденний прогрес, мати можливість перейти в наступний день циклу і претендувати на більші нагороди, учаснику необхідно виконати щоденну ціль хоча б один раз.",
    four: "Кампанія «Щоденні призи» проходить в циклах тривалістю до 5 календарних днів кожен з можливістю виконати щоденну ціль до 3 разів.",
    fourteen: "У разі збоїв все виграші анулюються.",
    list: "Правила и условия:",
    nine: "Для участі в акції не потрібно здійснювати додаткові депозити або робити внесків.",
    nineteen: "Щоден. ціль виконана 1 раз",
    one: "Час збирати урожай капусти вищого сорту в грошовому еквіваленті!",
    seven: "- якщо гравець пропустив день або не виконав щоденну ціль хоча б один раз;",
    seventeen: "Щоден. цілі",
    six: "Цикл щоденних нагород учасника скидається до першого дня в 2-х випадках:",
    sixteen: "День в циклі",
    ten: "Взяти участь в акції можливо тільки граючи на реальні гроші.",
    thirteen: "{company} залишає право в будь-який час припинити акцію на невизначений термін без виплати призів, а також змінювати правила без попереднього повідомлення.",
    three: "Для участі необхідно зіграти в будь-яку з ігор провайдера Booongo. Призовий фонд - до 1160 євро на учасника. Сума розраховується як максимальний загальний особистий призовий фонд, якщо учасник виконав всі можливі щоденні цілі протягом всієї кампанії (2 повних циклу). Сама соковита нагорода буде в останній день кожного циклу!",
    twelve: "Правила та умови участі можуть бути змінені в будь-який час виключно на розсуд {company}.",
    twenty: "Щоден. ціль виконана 2 рази",
    twentyFive: "до 1160 євро на учасника!",
    twentyFour: "Призовий фонд",
    twentyOne: "Щоден. ціль виконана 3 рази",
    twentySix: "Дата та час",
    two: "Щоб взяти участь, зіграйте в будь-яку з ігор провайдера Booongo і досягайте щоденних цілей."
  },
  cabinet: "Личный кабинет",
  calculated: "Рассчитанные",
  calculationID: "ID розрахунку",
  canNotChangeCurrency: "Не можна змінити валюту",
  canSelectSavedData: "Можете вибрати збережені дані",
  cancel: "Отмена",
  cancelBonus: "Відмовитися від бонусу",
  cancelBonusConfirm: "Вы уверены, что хотите отменить бонус? При отмене все бонусные средства будут аннулированы",
  cantEnterTheCode: "Не получается ввести код?",
  carriedOut: "Виконано",
  cashBackSum: "Сума миттєвого Cashback",
  cashBoxApproveCode: "Код подтверждения",
  cashBoxApproveCodeHint: "Потребуется кассиру для подтверждения вывода",
  cashBoxDeliveryText: "Для вашего удобства при сумме пополнения/вывода средств от {0} к вам может приехать курьер. Чтобы вызвать курьера, напишите нам в телеграм, логин {1}",
  cashbackTitle: "Cashback",
  cashboxAddress: "Адрес кассы",
  casino: "Казино",
  casinoBonus: "Бонус казино",
  casinoLogin: "{name}-логін",
  categoryFromAtoZ: "Категория от А до Я",
  change: "Змінити",
  changeData: "Изменить данные",
  changeEmail: "Изменить почту",
  changeMethod: "Изменить метод",
  changePassword: "Змінити пароль",
  changePhone: "Изменить номер",
  changeStatusCode: "Змінити статус коду",
  changeTheEmail: "Змінити пошту",
  changeWallet: "Изменить кошелек",
  changingEmail: "Изменение e-mail",
  changingPhone: "Изменение номера",
  checkRobotText: "Для перевірки, що ви не робот, натисніть на кнопку \"Підтверджую\"",
  checking: "Перевірка",
  chooseComfortableAddress: "Выберите удобный для посещения адрес",
  chooseDepositViaCryptocurrencyMethod: "Выберите метод «Пополнение через криптовалюту»",
  chooseVariantOrContinueEnter: "Выберите вариант или продолжите ввод",
  chooseVerificationMethod: "Выберите способ для отключения подтверждения вывода кодом",
  clear: "Очистить",
  clearFavorites: "Очистить избранное",
  clickCheckoutInHeaderOfSite: "Нажмите «Касса» в шапке сайта",
  clickHome: "Нажмите «На экран Домой»",
  clickOnTheOddsYouLike: "Кликая на понравившиеся коэффициенты, просто совершайте быстрые ставки во всплывающем окне:",
  clickSelectFrontCoin: "Нажмите “Выбрать” напротив монеты, например “Tether TRC20”",
  clickShare: "Нажмите «Поделиться»",
  clickToAttache: "Натисніть, щоб прикріпити файл",
  clickTopMenuToBuyCrypto: "Нажмите в верхнем меню  “Покупка крипто” и выберите способ оплаты “С банковской карты”. Мин. сумма - 10.40 USD",
  close: "Закрити",
  code: "Код",
  codeAlreadySendFillIt: "Отправили код подтверждения, введите его в поле ввода",
  codeIsWrong: "Код невірний",
  codeSend: "Смс-код отправлен на номер",
  codeSendToEmail: "Код отправлен на почту",
  codeSendToPhone: "Код отправлен на номер",
  codeSendToTelegram: "Код отправлен через бота в Telegram",
  codeVerificationDisabled: "Підтвердження кодом вимкнено",
  codeVerificationEnabled: "Підтвердження кодом увімкнено",
  coinSelection: "Выбор монеты",
  comboBoostBonus: {
    button: "Играть",
    content_title: "Как воспользоваться комбобустом:",
    good_luck: "Olymp.casino желает вам крупных выигрышей!",
    range_left_title: "Число событий",
    range_right_title: "Коэф.",
    step_one: "Шаг 1:",
    step_one_description: "Начните собирать свой выигрышный экспресс уже сейчас и обратите внимание, как получить увеличенный коэффициент.",
    step_three: "Шаг 3:",
    step_three_description: "Когда вы сделали свой выбор, совершите ставку! Бонус автоматически увеличит ваш итоговый коэффициент. Вы можете проверить свою ставку в разделе «Мои ставки». Она будет выделена маркером COMBOBOOST.",
    step_two: "Шаг 2:",
    step_two_description: "Продолжайте собирать свой экспресс и наблюдайте за увеличением бонуса.",
    welcoming_range_title: "Узнай свой коэфициент.",
    welcoming_text: "У Olymp.casino есть отличные новости для всех новых клиентов! Чтобы убедиться, что это работает, попробуйте эту возможность сами! Сделайте экспресс-ставку из 2-х или более событий с коэффициентом 1.5 и выше, чтобы увеличить итоговый коэффициент с помощью нашего бонуса. Имейте в виду, чем больше событий в экспрессе, тем больше будет ваш бонус.",
    welcoming_title: "Больше событий в ЭКСПРЕСС - больше Бонус!"
  },
  commission: "Комісія:",
  competitionAction: "Примите участие в турнире, сыграв в одну из указанных игр",
  competitionMembers: "учасників турніру",
  competitionParticipants: "Список учасників буде відображатися тут",
  competitionWinners: "Список переможців буде відображений тут",
  competitions: "Всі турніри",
  competitionsGames: "Турнірні",
  competitors: "{count} учасників турніру",
  completeRegistration: "Завершить регистрацию",
  completeSecuritySettings: "Завершите настройку безопасности личных данных и средств",
  completeSignIn: "Завершити авторизацію",
  completed: "Турнір завершений",
  conductError: "Помилка",
  confirm: "Підтвердити",
  confirmData: "Подтвердить данные",
  confirmInformation: "Підтвердити інформацію",
  confirmPersonalData: "Я підтверджую достовірність своїх персональних даних і розумію, що ця інформація не може бути змінена",
  confirmPhoneNumber: "Підтвердити номер телефону",
  confirmPhoneThroughTelegram: "Увійдіть у додаток Telegram і підтвердіть номер телефону для безпечного виведення коштів.",
  confirmationCode: "Код підтвердження",
  confirmationEmail: "Підтвердження email",
  confirmationPhone: "Підтвердження телефону",
  confirmed: "Підтверджений",
  congratulationsTrustWalletCreated: "Поздравляем! Кошелек Trust Wallet создан!",
  contact: "обратитесь",
  continueSecuritySetup: "Вернуться к настройке безопасности",
  converting: "автоматично конвертуються в",
  copeAddressMemo: "Мемо успішно скопійовано",
  copeAddressWallet: "Адреса гаманця успішно скопійована",
  copeAddressWalletNew: "Адрес вашего кошелька успешно скопирован",
  copeCode: "Код успешно скопирован",
  copeSumText: "Сумма успешно скопирована",
  copy: "Скопировать",
  copyAddress: "Скопіювати адресу",
  copyCode: "Скопировать код",
  copyTheAddress: "Скопируйте адрес",
  countries: {
    bangladesh: "Бангладеш",
    kazakhstan: "Казахстан",
    kyrgyzstan: "Кыргызстан",
    russia: "Россия",
    uzbekistan: "Узбекистан"
  },
  country: "Вибір країни",
  countryNotFound: "Страна не найдена, проверьте корректность написания",
  countrySelect: "Выбор страны",
  coupon: "Купон",
  couponContainsDependentOutcomes: "В купоне зависимые исходы",
  createWalletInTrustWallet: "Создайте кошелёк в Trust Wallet",
  cryptoMemo: "Мемо",
  cryptoTournament: "Крипто-турнір",
  cryptoWallerSuccessChanged: "Адреса гаманця змінена успішно",
  cryptoWallet: "Криптогаманець",
  cryptocurrency: "Криптовалюта",
  currency: "Валюта",
  current: "Поточні",
  currentBalanceIsLessThanTheWithdrawalAmount: "Доступны не все платежные методы, текущий баланс меньше минимальной суммы для совершения транзакции",
  currentRates: "Текущие ставки",
  customerSupport: "службою підтримки",
  customizeDisplayedCoins: "Для настройки отображаемых монет нажмите на ползунки в правом верхнем углу, на странице добавления токенов в строке поиска введите Doge. Активируйте монету Doge, нажав на ползунок напротив монеты",
  cyrillicInPasswordNotAvailable: "Кириллица в пароле недопустима",
  data: "Дата",
  dataNotSpecified: "Данные не указаны",
  date: "Дата",
  dateFrom: "Дата от",
  dateOfTransaction: "Дата транзакции",
  dateTo: "Дата до",
  deadline: "До закінчення залишилося",
  december: "декабря",
  decline: "Отклонено",
  demo: "Демо",
  deposit: "Депозит",
  depositAccount: "Поповнити рахунок",
  depositBK: "Поповнити з БК",
  depositBonus: "{bonus} бонус при поповненні",
  depositForBonus: "Здійсніть депозит на суму {sum} для завершення кроку",
  depositNoun: "Поповнення",
  depositRequired: "Необходимо совершить депозит от <span class='bonus-item__sum'>{sum}</span>",
  description: "Описание",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Слоти онлайн➔ грайте на ✓ гроші, ✓ безкошто{company}вно і ✓ без реєстрації. {company} казино представляє ✓ безкоштовні ✓ популярні ✓ сучасні ігрові автомати, від ✓ офіційних виробників, з ✓ щедрими бонусами та ✓ різноманітними темами."
    }
  },
  details: "Детальніше",
  docsWasApproved: "Документи успішно перевірені",
  docsWasDeclined: "Документи не пройшли перевірку",
  documentAttacheMessage: "Ми перевіримо їх протягом 24 годин. Після цього, всі платіжні методи стануть для Вас доступні.",
  documentAttacheSuccess: "Ваші документи успішно відправлені.",
  documentDeleteSuccess: "Документы были успешно удалены",
  documentNumber: "Номер документа",
  documentUpload: "Загрузка документов",
  done: "Готово!",
  doneThresholdConditions: "Выполнены условия отыгрыша депозита",
  download: "Завантажити",
  downloadApp: "Завантажити додаток",
  downloadOlimpApp: "Завантажити додаток Олімп",
  download_app: "Завантажити додаток Олімп",
  dropswins: {
    eight: "\"У випадковий момент проходять розіграші грошових призів на суму в 9000 €. Грай щоб виграти!\"",
    eighteen: "Правила та умови",
    eleven: "Таблиця призів щотижневого турніру (звичайні тижні)",
    fifteen: "Таблиця щоденних призів",
    five: "ЩОДЕННО",
    four: "ТУРНІР",
    fourteen: "Таблиця призів щотижневого турніру (звичайні тижні)",
    nine: "4 х 62 000 € щотижневих турнірiв",
    nineteen: " 1. Це мережева кампанія Pragmatic Play TM. Дана кампанія проводиться в період з 11.02.2021 по 17.11.2021 CET (c 1:01 11.02.2021 по 00:59 18.11.2021 EET) <br> 2. Кампанія проводиться в 10 етапів, де кожен етап триває 4 тижні. <br> 3. Загальний призовий фонд всієї акції становить 4 000 000 €, який складається з 40 x 62 000 € щотижневих турнірів і 40 x 63 000 € щотижневих розіграшів призів. <br> 4. Нижче наведені умови 7 етапу даної акції. Зверніть увагу, що механіка турніру змінюється в залежності від етапу. <br> 5. Щоб взяти участь в будь-якому турнірі або розіграші призів мережевої компанії, гравці повинні відкрити будь-яку з ігор, яка приймає участь, та підтвердити участь / погодитися з умовами. <br> 6. Чотири (4) тижні турнірів і розіграшів призів будуть проводитися наступним чином: <br> Тиждень 27: 11.08.2021 о 20:01 - 18.08.2021 о 19:59 EET <br> Тиждень 28: 18.08.2021 о 20:01 - 25.08.2021 о 19:59 EET <br> 7. Кваліфікаційні ігри: <br> Wolf Gold ™, Mustang Gold ™, Sweet Bonanza ™, John Hunter and the Tomb of the Scarab Queen ™, Great Rhino Megaways ™, John Hunter and the Book of Tut ™, The Dog House ™, The Dog House Megaways ™, Chilli Heat ™, Fruit Party ™, Big Bass Bonanza ™, Madame Destiny Megaways ™, Gems Bonanza ™, Wild Wild Riches ™, Wild West Gold ™, Gates of Olympus ™, Power of Thor Megaways ™, Buffalo King Megaways ™, The Hand of Midas ™, Floating Dragon Hold & Spin ™, The Magic Cauldron - Enchanted Brew ™, Heart of Rio ™, Dragon Hot Hold and Spin ™, Lucky Lightning ™, 5 Lions Megaways ™ ",
    one: "Приєднуйся до мережевого турніру Drops & Wins від Pragmatic Play, де кожен може стати переможцем!",
    seven: "\"Піднімись на вершину таблиці лідерів, отримавши найвищий виграш в одиночному оберті.",
    seventeen: "У цьому турнірі використовується механізм, який розраховує множник виграшу так, щоб участь в турнірі була справедливою для всіх гравців, незалежно від розміру ставки. Наприклад, якщо ти поставив 2 €, а виграв 10 €, то твій множник виграшу дорівнює п'яти. У цьому випадку ти отримаєш п'ять очок. Піднімись в Топ-1200 лідерів з найвищим виграшем в одиночному оберті.",
    six: "Відкрий запропоновані ігри, приєднуйся до турніру та починай грати (мінімальна ставка становить 0,50 євро)*",
    sixteen: "Для автоматичної участі в турнірі і розіграшах призів тобі потрібно приєднатися до кампанії всього один раз.",
    ten: "4 х 63 000 € щотижневих розіграшів призів",
    thirteen: "Нагорода",
    three: "ГРАЙ",
    twelve: "Місце",
    twenty: "Щотижневі турніри",
    twentyfour: "Миттєвий кешбек",
    twentyone: " 1. Таблиця лідерів формується відповідно до очок, а очки нараховуються на основі найбільшого виграшу за один спін, отриманого в будь-якій грі, яка бере участь в турнірі, з урахуванням суми ставки. <br> 2. Таблиця лідерів оновлюється в режимі реального часу, і гравці можуть переглядати таблицю лідерів у будь -який час, граючи в будь-яку з ігор, що бере участь у турнірі.<br> 3. У разі якщо два (2) або більше гравців закінчили турнір на одній і тій же позиції в таблиці лідерів, більш високе місце буде віддано гравцеві, який набрав таку кількість очок першим. <br> 4. Призи виплачуються гравцям у вигляді фіксованої суми. <br> 6. Щотижневий призовий фонд включає 1200 грошових призів загальною сумою в розмірі 62 000 €. <br> 7. МІСЦЕ - ТИЖНЕВІ ПРИЗИ <br> 1. € 10,000 <br> 2. € 5,000 <br> 3. € 2,000 <br> 4-10. € 1,000 <br> 11-20. € 500 <br> 21-50. € 200 <br> 51-100. € 100 <br> 101-300. € 50 <br> 301-600. € 20 <br> 601-1200. € 10 ",
    twentythree: " 1. Протягом кожного тижня акції проводиться сім (7) щоденних розіграшів призів. <br> 2. В ході кожної акції один (1) спін, який відповідає умовам, може принести один (1) приз з призового фонду. <br> 3. Призи розігруються на випадковій основі. Правила і таблиці призів доступні в іграх, які приймають учать в турнірі. Таблиця призів оновлюється в режимі реального часу, показуючи поточну позицію, а також кількість призів. <br> 4. Призи виплачуються, як зазначено на вкладці \"\"Призи\"\" в кожній грі, яка бере участь в турнірі. <br> 5. Призи виплачуються гравцям у вигляді фіксованої суми. <br> 6. Для участі в розіграші призів необхідно зробити мінімальну ставку на реальні гроші: 0,50 € в будь-якій з ігор, яка приймає участь у турнірі. Один гравець може виграти кілька призів протягом кожного дня. <br> 7. Розіграш призів припиняється щодня в (i) 00:59 EEST / EET або (ii) після присудження усіх призів (в залежності від того, що настане раніше). <br> 8. Якщо призовий фонд конкретного щоденного розіграшу не буде повністю розподілений, то будь-які надлишки коштів будуть переведені на розсуд PragmaticPlay ™ в призовий фонд наступного етапу. <br> 9. Щотижневий призовий фонд в цілому становить 63,000 €, а щоденний призовий фонд включає 500 грошових призів і безкоштовних раундів на загальну суму в 9,000 €. <br> 10. Кількість - Щоденні призи <br> 1 X € 1,000 <br> 2 X € 500 <br> 5 X € 100 <br> 12 X € 50 <br> 110 X € 20 <br> 370 X € 10 <br> 11. Переможці отримують свої призи в грошовій формі. Грошові призи будуть автоматично зараховані на їх ігрові рахунки в казино {baseLink} казино після закінчення турніру. <br> 12. {baseLink} залишає за собою право в будь-який момент, змінити або скасувати умови акції. <br> 13. Діють загальні правила і умови {baseLink}. ",
    twentytwo: "Щотижневі розіграші призів",
    two: "Призовий фонд у розмірі 500 000 € розподілений між етапами - 125 000 € в тиждень! Щоб взяти участь, просто виконай наступні кроки!"
  },
  email: "Email",
  emailNeedValid: "На почту придет проверочный код",
  emailSuccessfullyApproved: "E-mail успешно подтвержден",
  emptyGames: "Мы не нашли такие игры для вас",
  emptyPromoPage: "Тут будуть відображатися поточні акції",
  ended: "Завершено",
  engineeringWorks: "Через 5 хвилин на сайті проводитимуться технічні роботи",
  english: "Англійська",
  enter: "Вступити",
  enterCode: "Введите код",
  enterCodeFromEmail: "Введите код из email",
  enterCorrectPhoneNumber: "Введіть коректний номер телефону",
  enterCryptoWallet: "Ввести криптогаманець",
  enterCryptoWalletOnProfilePage: "Введіть криптогаманець Doge в особистому кабінеті для отримання виграшу",
  enterGameName: "Введіть назву гри!",
  enterGameNameOrProvider: "Введите название игры или провайдера",
  enterMoreCharacters: "Введіть більше символів!",
  enterPromoCode: "Введіть промокод",
  enterSMS: "Введіть код з SMS",
  enterSixDigitCode: "Введите 6-значный код из приложения",
  enterValidEmail: "Введите правильную почту",
  enterWalletAddress: "Вкажіть зараз чи потім адресу криптогаманця Doge для нарахування виграшу турніру.",
  enterYourBankCardDetails: "Введите данные банковской карты, согласитесь с условиями платежной системы и нажмите “Оплатить”",
  entrance: "Вхід",
  err404subtitle: "Чекаємо тебе на головній сторінці!",
  err404title: "На жаль, нічого не знайдено ... ",
  error: "Помилка",
  errorPasswordField: "Пароль повинен містити цифри, великі та малі літери",
  errorPaymentDataInitialization: "Ошибка при инициализации платежной системы",
  errorPaymentUrlInitialization: "Ошибка при инициализации платежа, попробуйте еще раз или обратитесь в службу поддержки",
  errorWhileSendingCode: "Отправка сообщения с кодом не удалась, попробуйте запросить его еще раз",
  errorsWhileValidate: "Ошибки при валидации формы",
  euro_slot: {
    description: "Euro Slots 2024 онлайн играть только в {platform} - лучшие официальные игровые слоты. Играй бесплатно и на деньги в онлайн казино.",
    end: "Турнир завершен",
    "final": "ФИНАЛ",
    inProgress: "Матч идет",
    mathPrize: "Призовой фонд матча:",
    onWallet: "на счет",
    prize: "Общий призовой фонд:",
    "prize-short": "ПРИЗ",
    prizeFond: {
      "1\/2": "Призовой фонд <p>1/2 финала:</p>",
      "1\/4": "Призовой фонд <p>1/4 финала:</p>",
      "1\/8": "Призовой фонд <p>1/8 финала:</p>",
      "final": "Призовой фонд <p>финала:</p>"
    },
    rules: {
      "1": "Акция проводится с 13.06.2024 00-00 GMT +5 по 14.07.2024 00-00 GMT +5",
      "2": "Общий призовой фонд турнира: {sum}",
      "3": "По расписанию проводится битва между слотами, которые двигаются по турнирной сетке",
      "4": "Пользователи, внесшие наибольший вклад в победу той или иной акционной игры, распределяют между собой призовой фонд",
      "5": "Даты для пар стадии 1/8 ({sum}):",
      "6": "Даты для пар стадии 1/4 ({sum}):",
      "7": "Даты для пар стадии 1/2 ({sum}):",
      "8": "Даты финала ({sum}):",
      "9": "Начисление призов происходит автоматически на игровой счет в течение 24 часов"
    },
    stage1: "<span>Регистрируйся</span> и жми кнопку «УЧАСТВОВАТЬ».",
    stage2: "<span>Ставь в любой</span> из участвующих игр и набирай очки.",
    stage3: "<span>Топ 130 игроков</span> разделят общий призовой фонд",
    stages: {
      "1\/2": "1/2 финала",
      "1\/4": "1/4 финала",
      "1\/8": "1/8 финала",
      "final": "финал"
    },
    stagesAtStart: {
      "1\/2": "До начала финала:",
      "1\/4": "До начала 1/2 финала:",
      "1\/8": "До начала 1/4 финала:",
      "final": "Финал",
      pre: "До начала 1/8 финала:"
    },
    start: "Как принять участие",
    table: "Турнирная таблица",
    title: "Турнир Euro Slots 2024 - Играть в слоты онлайн казино {platformSite}",
    winners: "Победители турнира"
  },
  events: "События",
  exchangeRateInTenge: "Курс валюты в тенге",
  exit: "Вихід",
  express: "Экспресс",
  expressCoef: "Коэффициент экспресса",
  expressSystem: "Система экспрессов",
  failed: "Дія не виконана",
  fastBet: "Быстрая ставка",
  fastbetDetailedDescription: "Быстрая ставка позволяет делать одиночные ставки всего в два клика. Запоминание суммы последней сделанной ставки дополнительно ускоряет процесс принятия ставок. Для использования активируйте флажок Быстрой ставки в меню:",
  fastbetSetting: "Настройки быстрой ставки",
  fastbetSum: "Сумма быстрой ставки",
  favorite: {
    added: "Гра додана у вибране",
    removed: "Гра видалена з вибраного"
  },
  favorites: "Вибране",
  february: "февраля",
  fieldRequire: "Поле обов'язкове для заповнення",
  fileAttached: "Файл прикріплено",
  fileNotAttached: "Файл не прикріплено",
  fillInformation: "Заповнити інформацію",
  fillProfileInfoForWithdraw: "Будь ласка, заповніть вашу особисту інформацію для виведення грошей.",
  fillRequiredInfoBelow: "Будь ласка, заповніть необхідну інформацію нижче",
  filter: "Фильтр",
  filterByDate: "Фильтр по дате",
  filtersText: {
    inTheNextSixHours: "в ближайшие 6 часов",
    inTheNextTwentyFourHours: "в ближайшие сутки",
    inTheNextTwoHours: "в ближайшие 2 часа",
    nextThreeDays: "в ближайшие 3 суток",
    nextTwelveHours: "в ближайшие 12 часов",
    nextWeek: "в ближайшую неделю",
    today: "Сегодня",
    tomorrow: "Завтра",
    whenever: "в любое время"
  },
  findOutAddressOfDogeWallet: "Узнайте адрес кошелька Doge",
  fine: "Хорошо",
  firstAuthMessage: "На номер телефону надіслано СМС із логіном та паролем. Поповніть рахунок та вирушайте за першими виграшами",
  firstDeposit: "На первый депозит!",
  forCorrectGamePushRefresh: "Для коректного відображення гри натисніть кнопку оновити",
  forEndCompetition: "До окончания турнира",
  forMoreInformation: "За дополнительной информацией",
  forStartCompetition: "До начала турнира",
  forgotPassword: "Забули пароль?",
  fraud: "Політика AML",
  freeBetsButton: "Ознакомиться",
  freeBetsCount: "Доступно фрибетов: ",
  freeBetsStepFour: "Сделайте ставку",
  freeBetsStepOne: "Перейдите в раздел «Спорт»",
  freeBetsStepThree: "Выберите событие",
  freeBetsStepTwo: "Активируйте «Фрибет» в вашем купоне",
  freeBetsTitle: "Free Bet on Sports",
  freeSpinsInGame: "Free Spins у грі",
  freespin: "Фріспін",
  freespinsAvailable: "Доступно фріспінів",
  from: "з {date}",
  fromAnySum: "От любой суммы",
  fromNumber: "от",
  fromSmth: "От {value}",
  fulfillConditionsForWithdrawal: "Выполните все условия для вывода средств.",
  fund: "Призовий фонд",
  future: "Майбутні",
  game: "Гра",
  gameDescTemplate: "Ігровий автомат {gameName} - онлайн слот від відомого розробника {providerName}. Грайте безкоштовно в ігровий автомат {gameName} або зареєструйтесь, щоб грати на гроші",
  gameForMoneyOnlyForAuthUser: "Гра на гроші доступна тільки авторизованим користувачам",
  gameInOtherTab: "Гра відкрита в іншій вкладці",
  gameNotAvailableBonus: "Гра недоступна через умови бонусу",
  gameNotAvailableGeoRestriction: "Игра недоступна в вашем регионе",
  gameNotFound: "Гра не знайдено",
  gameTitleTemplate: "Ігровий автомат {gameName}. Грати безкоштовно в онлайн казино {company}",
  gameUnavailable: "Гра тимчасово недоступна",
  game_categories: "Категории игр",
  games: {
    tryOther: "Спробуйте інші ігри"
  },
  gamesNotFound: "Ігри не знайдені",
  geoRestrictionDesc: "К сожалению, данная игра недоступна в вашем регионе.",
  geoRestrictionDescLine2: "Предлагаем вам выбрать другую игру из каталога",
  get: "Получить",
  getBonus: "Отримати бонус",
  getBonusByPromoCode: "Отримати бонус за промокодом",
  getGainFromFreeSpins: "Отримання виграшу з фріспінів",
  getNewCode: "Отримати новий код",
  getSMS: "Отримати SMS код",
  go: "Перейти",
  goBack: "Вернуться назад",
  goToGame: "Перейти к игре",
  goToGames: "Перейти к играм",
  goToHome: "Вернуться на главную",
  goToOlimpCasinoAndPlayFavoriteGames: "Переходите в Olimp Casino и играйте в любимые игры:)",
  goToVolet: "Перейдите на сайт volet.com (advcash)",
  goToWallet: "Перейти к кошельку",
  goesNow: "Йде зараз",
  gold: "Золото",
  guarantee: {
    five: "Самостійна відмова від гри. Якщо з метою зниження бажання грати Ви звернетеся в службу підтримки нашого казино з проханням заблокувати аккаунт, Ваша прохання буде виконано. Можливий варіант безповоротного видалення профілю гравця. В іншому випадку, за бажанням гравця, він може бути відновлений після закінчення деякого часу.",
    four: "Для гравців, охочих обмежити особистий доступ до гри, розроблені наступні варіанти:",
    one: "Відповідальна гра",
    seven: "Обмеження доступу. Якщо Ви хочете захистити себе від різних сайтів, що надають або рекламують азартні ігри, Вам слід використовувати спеціальне програмне забезпечення. Воно створює системи фільтрації і забезпечує безпечне перебування в інтернеті користувачів, схильних до гральної залежності. Крім цього, програмне забезпечення може бути використане для запобігання доступу дітей до небажаних ресурсів. Приклади подібного роду софта: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).",
    six: "Спеціалізована допомога. У разі розвитку гральної залежності гравці можуть вдатися до допомоги кваліфікованих фахівців. Вам можуть допомогти: Gamblers Anonymous (www.gamblersanonymous.org.uk) - міжнародне товариство анонімних гравців, що здійснює допомогу залежним гравцям; GamCare (www.gamcare.org.uk) - англомовна організація, яка допомагає гравцям позбутися залежності; Gambling Therapy (www.gamblingtherapy.org) - організація в Великобританії, що надає кваліфіковану підтримку в боротьбі з поширеним недугом.",
    three: "Якщо Ви відчули деяку залежність від гри, в першу чергу з'ясуйте, чим для Вас є азартні ігри. Якщо гра - це спроба втекти від життєвих складнощів, якщо вона забирає майже весь Ваш вільний час і заважає роботі, це вже перший дзвіночок. Якщо ж Ви позичаєте гроші для гри і більше не уявляєте свій день без неї, це вірний показник того, що Вам необхідні рішучі зміни.",
    two: "{titlePure} несе певну відповідальність перед користувачами, що грають на сайті. Адміністрація казино готова допомогти гравцям впоратися з можливим виникненням гральної залежності. Суть гри полягає в тому, щоб доставляти позитивні емоції і давати розрядку. Зрозуміло, можуть траплятися і невдачі, але це ні в якому разі не повинно викликати будь-які фінансові або соціальні складності."
  },
  hasMinimalDeposit: "Внесен минимальный депозит",
  haveActivatedFastbetMode: "Вы активировали режим быстрой ставки. Для ознакомления с правилами, пожалуйста, нажмите",
  haveNotEmailContactUs: "Якщо вам не надійшов лист на пошту, будь ласка, перевірте папку \"Спам\" і \"Промоакції\" або зв'яжіться з {0}",
  haveNotPhoneContactUs: "Если вам не пришла смс на ваш номер телефона свяжитесь со {0}",
  here: "Здесь",
  hiddenConditions: "Приховані умови",
  hide: "Сховати",
  hideBonusCondition: "Приховати умови бонусу",
  hideDetails: "Скрыть подробности",
  history: "Історія",
  historyBets: "Історія ставок",
  historyPayments: "Історія платежів",
  historyTransactions: "История транзакций",
  hotGame: "Гаряча",
  hotGames: "Горячие игры",
  hotToBuyCryptoCurrency: "Как купить криптовалюту?",
  howCanBuyCryptocurrency: "Як я можу купити криптовалюту?",
  howCreateCryptoWallet: "Як створити криптогаманець?",
  howCreateWallet: "Як створити гаманець?",
  howToCreateCryptoWallet: "Как создать криптокошелёк?",
  howToFindOutWalletNumber: "Как узнать номер кошелька?",
  howToInstallApp: "Как установить приложение?",
  howToViewMyCryptoWalletInOlimp: "Как посмотреть мой крипто-кошелёк в Олимпе?",
  howTopUp: "Как пополнить",
  howTransferCrypt: "Як перевести криптовалюту",
  howTransferCryptStep1: "Зайти в гаманець чи біржу",
  howTransferCryptStep2: "Знайти вибрану монету {currency}",
  howTransferCryptStep3: "Вставити адресу нашого гаманця",
  howTransferCryptStep4: "Вказати та надіслати суму",
  iPaid: "Я пополнил",
  idWasCopied: "Вы скопировали id транзакции",
  inSettings: "в настройках",
  information: "Інформація",
  informationConfirmWithdraw: "Підтвердіть всі свої дані для безпеки та виведення коштів. Щоб змінити адресу електронної пошти або номер телефону, зв'яжіться з",
  informationConfirmWithdrawSupport: "службою підтримки",
  informationForUpdateProfileData: "Чтобы обновить контактные данные, необходимо обратиться в службу поддержки",
  installApp: "{0} за установку приложения",
  installTrustWalletApp: "Установите приложение Trust Wallet",
  instant: "Швидкі",
  instantCash: "Cashback",
  instantCashback: "Миттєвий cashback",
  instantWithdrawal: "Миттєве виведення",
  instantly: "Мгновенно",
  insufficientFundsAvailable: "Недостатньо коштів. Доступно:",
  invalidCryptoWallet: "Невірна адреса гаманця",
  invalidDateFormat: "Неверный формат даты",
  invalidDateInterval: "Выбранный интервал неверный",
  invalidStartDate: "Неверная начальная дата",
  iosWebAppInstruction: "Инструкция iOS",
  jackpot: "Джекпот",
  jackpotGame: "З джекпотом",
  january: "января",
  july: "июля",
  june: "июня",
  kazakh: "Казахська",
  kycPolicy: "KYC політика",
  latestGames: "Недавние игры",
  leftCount: "Залишилось {count}",
  leftDeposit: "Залишилося поповнити {sum}",
  licenseCuracao: "Вміст веб-сайту належить і управляється Perantia N.V. (<a href='https://olimp.com' target='_blank'>olimp.com</a>) як власником ліцензії (ліцензія Кюрасао №365/JAZ). Усі права захищені та охороняються законом.",
  lineOn: "Линия на",
  linkIsReady: "Ссылка готова",
  liveCashBackDesc: "{company} пропонує ексклюзивний бонус, доступний тільки для наших VIP-клієнтів! Робіть ставки в іграх із категорії “LIVE Казино” та отримуйте на ігровий рахунок суму Cashback залежно від суми програних ставок! ",
  liveCashback: "Live кешбек",
  liveCashbackHistory: "Історія Live cashback",
  live_casino: "LIVE Казино",
  loading: "Загрузка",
  loadingLanguage: "Завантаження мови",
  lobby: "Головна",
  login: "Логін",
  loginCopied: "Ваш логин скопирован",
  loginErr: "Логін {name} не повинен містити літери!",
  loginTelegram: "Увійти за допомогою Telegram",
  logoutFromSystem: "Вихід з системи",
  lose: "Поразка",
  losers: "Проигравшие",
  lottery: "Лотерея",
  mainPage: "Главная страница",
  makeABet: "Сделать ставку",
  makeBet: "Сделать ставку",
  makeDeposit: "Внести депозит",
  march: "марта",
  matchClosed: "Матч закрыт",
  matchEnded: "Матч завершен",
  matchNotFound: "Матч не найден",
  matchPlanned: "Матч планируется",
  matches: "Матчи",
  maxBet: "Максимальная ставка",
  maxForExpress: "Максимум для экспресса",
  maxLength: "Максимальная длина поля {length}",
  maxOutput: "Мінімальна сума виведення",
  maxPay: "Максимальна сума оплати",
  maxSum: "Макс. сумма",
  maxValue: "Максимальное значение {value}",
  maxValueShort: "Макс: {value}",
  maxWithdrawSum: "Максимальна сума виведення",
  maximumPayment: "Максимальна сума оплати:",
  may: "мая",
  messageSMS: "Введіть код з смс",
  messages: "Повідомлення",
  middleName: "По батькові",
  minBet: "Минимальная ставка",
  minDepositForBonus: "Здійсніть депозит на суму щонайменше {sum} для завершення кроку",
  minLength: "Минимальная длина поля {length}",
  minLengthPassword: "Минимальная длина пароля {min} символов",
  minOutput: "Термін зарахування",
  minPay: "Мінімальна сума оплати",
  minSum: "Мин. сумма",
  minValue: "Минимальное значение {value}",
  minValueShort: "Мин: {value}",
  minimalDeposit: "Мінімальний депозит",
  minimalLengthOfCode: "Мінімальна довжина коду {num} символів",
  minimalSum: "Мінімальна сума",
  minimumPayment: "Мінімальна сума оплати:",
  minimumTransfer: "Мінімальна сума переказу на рахунок:",
  modal_telegram: "Активні бонуси та акції, щотижневі розіграші та багато іншого ти знайдеш у нашому каналі, а з ботом ніколи не втратиш доступ до сайту!",
  more: "Ще",
  moveToBonus: "Перейти до бонусу",
  moveToMessages: "Перейти до Повідомлень",
  myBalances: "Мои балансы",
  myBonuses: "Мої бонуси",
  name: "Назва",
  namePerson: "Ім'я",
  nameTheCheckout: "Назовите адрес кошелька кассиру",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "BetGamesTV",
    fantasy: "Fantasy",
    fast: "Швидкі",
    jetx: "JetX",
    line: "Лінія",
    live: "Live",
    liveGames: "LiveGames37",
    lottery: "Лотерея",
    online: "Live Казино",
    slot: "Слоти",
    sportGames: "Sport games",
    table: "Настільні",
    turboGames: "Turbo games",
    vSport: "V-Sport",
    virtualGames: "Віртуальні",
    worldcup: "ЧС-2022"
  },
  navLinks: {
    bonuses: "Бонуси",
    home: "Головна",
    homeCasino: "Casino",
    posts: "Повідомлення",
    profile: "Профіль",
    promo: "Акции",
    sport: "Спорт",
    tournament: "Турніри"
  },
  needConfirmProfileInformation: "Для активації бонусу підтвердіть інформацію про себе у профілі",
  needDeposit: "Необходимо сделать депозит",
  needSettingsSecurity: "Необходимо пройти настройки безопасности",
  needToExecuteConditions: "Необходимо выполнить условия",
  never: "Никогда",
  "new": "Нові",
  new2: "Нове",
  newBonusAvailable: "Вам доступний новий бонус",
  newGame: "Нова",
  newMessage: "Нове повідомлення",
  newMessages: "Нові повідомлення",
  newOne: "Нове",
  newVersionReloadPage: "Версія сайту оновилася, для коректної роботи поновіть сторінку",
  newYearPromocodes2025: {
    NY25DAY1: "50 FS в игре Santa's Gift",
    NY25DAY10: "Фрибет на спорт!",
    NY25DAY11: "50 FS в игре Santa's Great Gifts",
    NY25DAY12: "75 FS в игре Royal Xmass 2",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Santa's Xmas Rush",
    NY25DAY2: "Фрибет на спорт!",
    NY25DAY3: "50% к депозиту и 50 FS в подарок!",
    NY25DAY4: "75 FS в игре Buffalo Power: Christmas",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Royal Xmass",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!"
  },
  next: "Далі",
  nextGames: "Показати ще",
  no: "Ні",
  noAccount: "Нет аккаунта",
  noBetsInHistory: "В Вашей истории нет ставок",
  noConnectionTryAlready: "Нет соединения с интернетом. Подключитесь к Интернету и попробуйте еще раз.",
  noDeposit: "Без депозита",
  noFavoritesYet: "В избранном пока ничего нет",
  noMatchSelected: "Не выбран ни один матч либо нет событий в линии!",
  noResults: {
    bets: "Тут будуть відображатися ваші ставки",
    bonuses: "Тут будуть відображатися доступні бонуси",
    competitions: {
      active: "Тут будуть відображатися активні турніри",
      all: "Тут будуть відображатися активні турніри",
      ended: "Тут будуть відображатися минулі турніри",
      future: "Тут будуть відображатися майбутні турніри"
    },
    gamesNotFound: "Ігор не знайдено",
    gamesSearch: "Ігор за Вашим запитом не знайдено, спробуйте ввести інший запит",
    messages: "Тут будуть відображатися ваші повідомлення",
    payin: "У вас немає доступних способів поповнення",
    payout: "У вас немає доступних способів виведення",
    simple: "Немає результатів",
    transactions: "Тут будуть відображатися ваші транзакції",
    withdraw: "Тут будуть відображатися ваші заявки на виведення коштів"
  },
  noSelectionsForBetting: "Не выбраны исходы для ставки",
  nomination: "Номінація турніру",
  nonBonusGame: "Гра не бере участі в бонусній програмі. Ми перемкнемо ваш рахунок на основний.",
  nonBonusGameBetsNotCountInVager: "Игра не участвует в бонусной программе. Ставки не учитываются в вейджере бонуса",
  nonBonusGameWithoutBalance: "Гра не бере участі у бонусній програмі. Щоб грати, поповніть основний рахунок.",
  notBonuses: "Зараз немає доступних бонусів",
  notCompetition: "Зараз немає активних турнірів",
  notConfirmed: "Не підтверджений",
  notDeposit: "не було поповнень",
  notEnoughEventsForExpress: "Недостаточно  событий для экспресса",
  notEnoughEventsForSystem: "Недостаточно  событий для системы",
  notEnoughMoneyToWithdraw: "Недостаточно денег для вывода",
  notEnoughVventsForSystem: "Недостаточно  событий для системы",
  notInterested: "Не цікаво",
  notLogin: "Введіть логін {name}!",
  notNow: "Не зараз",
  notPass: "Введіть пароль!",
  notSufficient: "Не достаточный",
  notValidValue: "Не правильне значення",
  notification: "Повідомлення",
  november: "ноября",
  nowInLine: "Сейчас в линии",
  nowPlayed: "Зараз відіграно",
  numberErr: "Будь ласка, перевірте номер вказаний при реєстрації",
  numberOfWallet: "Номер кошелька",
  october: "октября",
  onAccountBK: "На рахунку БК:",
  oneClick: "Умножай банк в один клик",
  online: "Онлайн",
  onlyForYou: "Только для Вас",
  open: "Відкрити",
  openAppTrustWallet: "Откройте приложение и вам будет доступно две функции - зарегистрировать новый кошелёк или восстановить имеющийся. Нажмите нажать на «Создать новый кошелек»",
  openEmail: "Открыть email",
  openGameNewTab: "Для відкриття гри натисніть на кнопку",
  openSafari: "Откройте в Safari",
  openSafariIfAnotherBrowser: "Если вы находитесь в каком либо другом браузере, откройте данную страницу в браузере Safari",
  openTelegramBot: "Відкрити телеграм-бот",
  operations: "Історія операцій",
  orders: "Замовлення",
  ordinary: "Ординар",
  ordinarySeries: "Серия ординаров",
  other: "Другие",
  otherSections: "Інші розділи",
  ourSocialMedia: "Наші соціальні мережі",
  ourSocialMediaShort: "Наші соц. мережі",
  out: "Вийти",
  output: "Виведення",
  outputModalTitle: "Подтверждение вывода",
  outputSuccess: "Виведення коштів успішно завершено!",
  overallCoef: "Общий коэффициент",
  page: "Страница",
  pageErr: "Сторінку не знайдено",
  pageErrDesc: "Страница удалена или адрес введен некорректно",
  pageNotFound: "Cтраница не найдена!",
  pageNotFoundDesc: "Страница удалена или адрес введен не корректно",
  participant: "Учасник",
  participate: "Брати участь",
  passErr: "Забули пароль?",
  passMessage: "Пароль повинен містити цифри, великі і маленькі букви",
  passportIndex: "Номер паспорта / ID",
  password: "Пароль",
  passwordChanged: "Пароль змінено",
  passwordErr: "Реєстрація",
  passwordNew: "Новий пароль",
  passwordSuccess: "Пароль успішно відновлено",
  passwordTheSame: "Пароль должен отличаться от текущего",
  past: "Минулі",
  pay: "Выплата",
  payBonusErr: "Для покупки бонусу, залишилося зробити депозит на суму не менше",
  payMethod: "Спосіб поповнення",
  payMethods: "Способи поповнення",
  paymentMethod: "Спосіб оплати:",
  paymentSuccess: "Переказ коштів успішно завершено!",
  payoutPayTrxsExistsText: "Для вывода средств необходимо совершить хотя бы одно пополнение",
  payoutThresholdStatusText: "Для вывода средств необходимо отыграть {count}",
  period: "Період",
  personInformationIsApprove: "Личная информация подтверждена",
  personalArea: "Особистий кабінет",
  personalData: "Особисті дані",
  personalDataApproved: "Личные данные подтверждены",
  personalDataIsFilled: "Личные данные заполнены",
  personalDataSuccessfullyEdited: "Ваші персональні дані успішно змінені",
  phone: "Телефон",
  phoneErr: "Номер телефону не може містити букви!",
  phoneNum: "Номер телефону",
  phoneSuccessfullyApproved: "Телефон успешно подтвержден",
  pickUpBonus: "Забрати бонус",
  place: "Місце",
  placeAQuickBet: "Сделать быструю ставку?",
  places: "Призових місць",
  placesCount: "{count} місць",
  placesPrice: "Призових",
  play: "Грати",
  playAviator: "Играть в авиатор",
  playBonus: "Вітаємо, ви відіграли бонус! Виведення коштів буде доступним після поповнення балансу на суму від {count} Бонус завершений. Для продовження гри поповніть рахунок на суму від {count}",
  playBonusEnded: "Бонус аяқталды. Ойынды жалғастыру үшін есеп шотыңызды {count} сомасына толтырыңыз.",
  playForMoney: "Грати на гроші",
  playGamesInCategoryes: "Сыграйте в игры из категорий",
  playWithoutBonus: "Грати без бонусу",
  playingInAppMoreConvenient: "Играть в приложении удобнее",
  pleaseConfirmAgreementToTheTerms: "Пожалуйста, подтвердите согласие с условиями",
  pleaseConfirmInformation: "Будь ласка, підтвердіть інформацію",
  pleaseSelectOutcome: "Пожалуйста, выберите исход",
  pleaseUseNumberOfCharacters: "Будь ласка, використовуйте {num} символів",
  point: "Очки",
  points: "нет очков | {n} очко | {n} очка | {n} очков",
  postSMS: "Відправити смс-код",
  posts: "Повідомлення",
  potentialWin: "Потенциальный выигрыш",
  ppenFullBetHistory: "Открыть полную историю ставок",
  preparedForRemoval: "Подготовленно к снятию (в обработке)",
  preview: "Попередній перегляд",
  prize: "Приз",
  prizes: "Призи переможців",
  proceed: "Продовжити",
  processDeposit: "Обработка пополнения",
  processDepositDescription: "Платеж отправлен и находится в обработке на стороне платежной системы. Срок зачисления средств может составлять от нескольких минут до нескольких дней",
  processWagerFromBonusBalance: "Виконання вейджера від бонусного балансу",
  processWagerFromDeposit: "Виконання вейджера від суми депозиту",
  processed: "В обработке",
  processing: "В обробці",
  promo: "Акции",
  promoCodeActivationSuccess: "Промокод успешно активирован",
  promoGames: "Бонусні ігри",
  promoMaxBetExceeded: "Максимальна ставка, дозволена бонусом {bet} {currency}",
  promoNotFound: "Нет действующих акций",
  promocode: {
    activate: "Активировать промокод",
    placeholder: "Промокод",
    title: "Активация промокода"
  },
  promocodes: {
    NY25DAY1: "50 FS в игре Hell Hot 100",
    NY25DAY10: "50 FS в игре Santa's Great Gifts",
    NY25DAY11: "Фрибет на спорт!",
    NY25DAY12: "Фрибеты на Aviator",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Sugar Rush Xmas",
    NY25DAY2: "50% к депозиту и 50 FS в подарок!",
    NY25DAY3: "Фрибет на спорт!",
    NY25DAY4: "Фрибеты на JetX",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Twin fruits of Santa",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!",
    NYDAY1: "50 FS в игре Hell Hot 100",
    NYDAY10: "50 FS в игре Santa's Great Gifts",
    NYDAY11: "Фрибет на спорт!",
    NYDAY12: "Фрибеты на Aviator",
    NYDAY13: "75% к депозиту и 75 FS в подарок!",
    NYDAY14: "100 FS в игре Sugar Rush Xmas",
    NYDAY2: "50% к депозиту и 50 FS в подарок!",
    NYDAY3: "Фрибет на спорт!",
    NYDAY4: "Фрибеты на JetX",
    NYDAY5: "75% к депозиту и 75 FS в подарок!",
    NYDAY6: "75 FS в игре Twin fruits of Santa",
    NYDAY7: "100% к депозиту и 100 FS в подарок!",
    NYDAY8: "100 FS в игре Sugar Rush Xmas",
    NYDAY9: "50% к депозиту и 50 FS в подарок!"
  },
  promocodes2025: {
    NY25DAY1: "50 FS в игре Santa's Gift",
    NY25DAY10: "50 FS в игре Santa's Great Gifts",
    NY25DAY11: "Фрибет на спорт!",
    NY25DAY12: "75 FS в игре Royal Xmass 2",
    NY25DAY13: "75% к депозиту и 75 FS в подарок!",
    NY25DAY14: "100 FS в игре Santa's Xmas Rush",
    NY25DAY2: "50% к депозиту и 50 FS в подарок!",
    NY25DAY3: "Фрибет на спорт!",
    NY25DAY4: "75 FS в игре Buffalo Power: Christmas",
    NY25DAY5: "75% к депозиту и 75 FS в подарок!",
    NY25DAY6: "75 FS в игре Royal Xmass",
    NY25DAY7: "100% к депозиту и 100 FS в подарок!",
    NY25DAY8: "100 FS в игре Sugar Rush Xmas",
    NY25DAY9: "50% к депозиту и 50 FS в подарок!"
  },
  promotionNotFound: "Такой акции не существует",
  protectYouData: "Обезопасьте свои личные данные и средства",
  protection: "Політика конфіденційності",
  protectionSettingsMessage: "Настройка безопасности аккаунта необходима для сохранения ваших средств и безопасного их вывода",
  providers: "Провайдери",
  purchaseCryptocurrency: "Покупка криптовалюты",
  putSend: "Отримати код",
  queue: "У черзі",
  reSendCode: "Отправить код повторно",
  read: "Прочитано",
  readyForWithdrawOnCashier: "Готово к выплате на кассе",
  receiveWithdrawalConfirmation: "Отримати підтвердження виведення коштів електронною поштою/Telegram",
  recomend: "Рекомендуем",
  recovery: "Відновлення паролю",
  recoveryEmailDesc: "Щоб отримати доступ до свого облікового запису, введіть e-mail, який ви вказали при реєстрації",
  recoveryPassword: "Восстановить пароль",
  recoveryPhoneDesc: "Щоб отримати доступ до аккаунту, введіть номер телефону, який ви вказали при реєстрації",
  recoveryWord: "Відновлення",
  refill: "Поповнення рахунку",
  refresh: "Оновити",
  refreshPage: "Обновить страницу",
  refund: "Повернення",
  refundPolicy: "Політика повернення",
  refundWithdrawal: "Отменить вывод",
  refundWithdrawalModalDesc: "Вы уверены, что хотите отменить вывод средств? При отмене средства вернутся на основной баланс.",
  refundWithdrawalNoun: "Отмена вывода",
  reg: "Реєстрація",
  register: "Зареєструватися",
  registrationBonus: "Бонус за регистрацию",
  rejected: "Отклонено",
  remainingPlay: "Залишилося відіграти",
  repeatPassword: "Повторите пароль",
  repeatTopUpDesc: "Платіж не пройшов? Спробуємо ще раз?",
  replenishment: "Поповнення",
  requirement: "Вимога",
  requisiteDesc: "Для пополнения счета переведите {sum} на счет. Для успешного пополнения, сумма должна полностью совпадать с указанной.",
  resend: "Відправити повторно",
  resendCodeCanAfter: "Отправить повторно код можно через {0}",
  reset: "Скинути",
  resetFilters: "Сбросить фильтр",
  resetIt: "сбросить его",
  responsibleGame: "відповідальна гра",
  result: "Итог",
  results: "Результаты",
  resultsSearch: "Результаты поиска",
  "return": "Возврат",
  rollback: "Відкат",
  rules: "Правила та умови",
  rulesDescription: "Правила",
  rulesShort: "Правила",
  rulesTournament: "Умови і правила турніру",
  russian: "Російська",
  sales: "Продано",
  save: "Зберегти",
  schedule: "Расписание",
  scores: "очок",
  search: "Пошук",
  searchProviders: "Название провайдера",
  seats: "Места",
  secretAnswer: "Ответ на контрольный вопрос",
  secretQuestion: "Ответ на контрольный вопрос",
  security: {
    five: "Якщо у вас залишаються питання щодо захисту інформації, будь ласка, зверніться в службу онлайн підтримки або надішліть листа на адресу {support}. Ми будемо раді допомогти вам.",
    one: "Щоб показати нашу тверду позицію в питанні ведення бізнесу за світовими стандартами, ми публікуємо це положення про захист інформації.",
    seven: "Захист інформації",
    six: "Послуги та інформація на сайті надані компанією \"Euromirbet d.o.o.\", Podgorica, Cetinjski put bb, reg. no. 5-0685623 / 1. Відповідно до рекомендацій Payment Card Industry Security Standards Council, для захисту даних покупця використовується шифрування на транспортному рівні - TLS 1.2 і на прикладному рівні алгоритмом AES з довжиною ключа 256 біт",
    three: "{titlePure} дотримується анти-спам політики. Всі листи, що відправляються нашим гравцям, мають відношення до їх ігрових акаунтів, а також можуть містити інформацію про їх нові можливості в казино і актуальні промо матеріали. Частота рекламних розсилок може варіюватися і досягати до 3 листів на добу. Гравці залишають за собою право відмовитися від розсилки - в такому випадку необхідно звернутися до служби онлайн підтримки або відписатися в будь-який час, натиснувши на відповідне посилання внизу листа. Інформація про ваші виграші і здійснені вами платежі також є суворо конфіденційною і зберігається в безпечному середовищі.",
    two: "Ми віримо, що правильні бізнес відносини будуються тільки на чесності та довірі. Тому конфіденційність вашої інформації надзвичайно важлива для нас. Ви можете насолоджуватися грою, знаючи про те, що ми вживаємо всіх заходів щодо забезпечення збереження ваших транзакцій. Ваше ім'я, поштова адреса e-mail адреса, телефонний номер, дата народження, стать, IP адреса та інша інформація є приватною і конфіденційною і не підлягає передачі, продажу та розповсюдженню третім особам."
  },
  securityAnswer: "Секретна відповідь",
  securityQuestion: "Секретне питання",
  securitySetting: "Настройка безопасности",
  selectAll: "Выделить все",
  selectApproveMethod: "Выберите способ подтверждения вывода",
  selectCountryToReceive: "Выберите страну, чтобы получать актуальные предложения и условия в регионе",
  selectPaymentCurrencyAndClickTopUpAccount: "Выберите валюту расчета и нажмите «Пополнить счет»",
  selectProviders: "Всі ігри по обраним провайдерам",
  selectQuestion: "Спочатку виберіть питання",
  selectVariable: "Виберіть відповідний варіант",
  sellBet: "Продать ставку",
  send: "Відправити",
  sendCode: "Надіслати код",
  sendCodeError: "Не получается ввести код, обратитесь",
  sendCodeErrorSupport: "в поддержку",
  sendCodeRepeat: "Отправить код еще раз",
  sendCodeSuccess: "Код надіслано на телефон",
  sendCodeSuccessEmail: "Код надіслано на пошту",
  sendConfirmationEmail: "Ми надіслали email з підтвердженням на",
  sendConfirmationPhone: "Мы отправили смс с кодом на номер {phone}",
  sendDocuments: "Надіслати документи",
  sendSMS: "Відправити SMS код",
  sendedCodeToEmail: "Отправили 6-значный код на почту",
  sendedCodeToPhone: "Отправили 6-значный код на телефон",
  september: "сентября",
  serverErrorTryAgain: "Помилка сервера, спробуйте ще раз",
  serverErrorTryRefresh: "Помилка сервера, спробуйте оновити",
  settlementCurrency: "Валюта расчетов",
  sgtv_bonus: {
    block_one_li_four: "Получите 10 фрибетов.",
    block_one_li_one: "Для получения бонуса необходимо иметь на балансе от {sum} {currency}.",
    block_one_li_three: "Активируйте бонус в Меню.",
    block_one_li_two: "Для активации бонуса перейдите в любую игру провайдера SGTV.",
    block_one_title: "Как получить свой бонус:",
    block_two_li_eight: "Бонус облагается вейджером х20. Минимальный коэффициент при отыгрыше равен 1.5.",
    block_two_li_eleven: "Olymp оставляет за собой право единолично и в любой момент изменить или отменить условия предложения, а также отказать любому игроку без объяснения причин.",
    block_two_li_five: "Новому игроку начисляется 10 фрибетов номиналом {sum} {currency} при входе в раздел Sport Games.",
    block_two_li_four: "Бонус добавляется мгновенно. Если выбранный бонус не был добавлен, необходимо обратиться в службу поддержки до начала игры. Если вы начнете игру без бонуса, он не будет начислен.",
    block_two_li_nine: "Максимальная доступная к выводу сумма выигрыша с бездепозитных фрибетов и бездепозитных бонусов - {sum} {currency}.",
    block_two_li_one: "Пользователь имеет право только на один бонус.",
    block_two_li_seven: "Бонус доступен в течение 3 дней с момента активации.",
    block_two_li_six: "Фрибеты можно использовать в играх «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты».",
    block_two_li_ten: "Фрибеты можно использовать для ставок на коэффициент от 1.3 до 5.",
    block_two_li_three: "Для получения бонуса необходимо сделать пополнение от {sum} {currency}.",
    block_two_li_two: "Бонусы (фрибеты) выдаются игрокам, которые ни разу не совершали ставки в SportgamesTV.",
    block_two_title: "Условия и положения:",
    important_text: "Важно! Если вы начнете игру не активировав бонус, то фрибеты не будет добавлены в последствии.",
    title: "Фрибеты для новых игроков в SportGamesTV! Получите 10 бесплатных ставок в играх «Нарды», «Бокс», «Дартс», «Бридж», «Буллиты»."
  },
  shallWePlay: "Пограємо?",
  shortDescription: "Короткий опис",
  show: "Показать",
  showAll: "Показати все",
  showBets: "Показати ставки",
  showCodeOnlyForOperator: "Не сообщайте код подтверждения никому кроме кассира",
  showGame: "Показати гру",
  showGames: "Показати ігри",
  showMatchesStarting: "Показать матчи, начинающиеся:",
  showMoreGames: "Показать больше игр",
  showTerms: "Показать условия",
  showTransactions: "Показать транзакции",
  signUp: "Реєстрація",
  signUpAndVerifyVolet: "Зарегистрируйтесь и пройдите верификацию, которая занимает 15 минут",
  signin: "Войти",
  silver: "Срібло",
  slots: "Слоти",
  smallDescription: "Короткий опис турніру",
  smsCode: "Отримати SMS код",
  smsInfo: "На ваш номер буде відправлено SMS код",
  smsSendingDesc: "Введіть код, який ми відправили на номер",
  smsVer: "SMS верифікація платежів",
  smsVerDisabled: "SMS верифікація платежів відключена",
  smsVerEnabled: "SMS верифікація платежів включена",
  socialAuthError: "Помилка авторизації через соціальну мережу",
  soonStarted: "Скоро розпочнеться",
  sort: "Сортировать",
  spaceNotAvailableForField: "В этом поле пробелы недопустимы",
  specifyNumberYourPersonalCryptoWallet: "В поле укажите номер вашего личного крипто-кошелька на сайте Olimp.com.",
  spinsBeforeCrediting: "Кількість обертів до зарахування:",
  sportErrorText: "Мы сейчас обновляем раздел «Спорт», но уже скоро всё восстановим.",
  sports: "Спорт",
  stakeHasBeenSuccessfully: "Ваша ставка успешно принята!",
  startSecuritySetup: "Пройти настройку безопасности",
  stateOfAnAccount: "Состояние счета",
  status: "Статус",
  statusAcc: "Статус облікового запису",
  statusOfTransaction: "Статус транзакции",
  statusSuccess: "Подтверждено",
  statuses: {
    calculationInProgress: "Йде розрахунок",
    inProcess: "В процесі",
    notPayed: "Не виплачено",
    payed: "Виплачено"
  },
  sub_telegram: "Підпишись на телеграм",
  success: "Дія пройшла успішно",
  successEnterTournament: "Чудово, Ви в турнірі!",
  successPromoCode: "Промокод успешно активирован",
  sufficient: "Достатній",
  sum: "Сума",
  sumBet: "Сумма ставки",
  sumMoreThanBalance: "Сумма больше чем на балансе",
  sumWithdraw: "Сума виплати",
  support: "Підтримка",
  supportContact: "Обратиться в поддержку",
  surname: "Прізвище",
  suspended: "Приостановлен",
  system: "Система",
  table: "Настільні",
  tapOnHome: "Тапните на пункт «На экран Домой», и нажмите «Готово»",
  tapOnShareIcon: "Тапните на иконку «Поделиться» в меню в нижней части экрана. Откроется диалоговое окно",
  term: "Термін зарахування",
  termEnrollment: "Термін зарахування:",
  termFulfillment: "Термін на виконання умов:",
  termsAndConditions: "Умови та положення",
  termsAndConditionsList: "Условия и положения",
  timeFulfill: "Час для виконання умов:",
  timeRemaining: {
    txt: "Залишилося {seconds} секунд, щоб отримати код ще раз",
    txtPay: "Отримати новий код можна буде через {seconds}"
  },
  timeToActivateBonus: "Час на активацію бонусу",
  timer: {
    oneLetter: {
      day: "д",
      hour: "ч",
      minute: "м",
      second: "с"
    },
    "short": {
      day: "дн.",
      hour: "год.",
      minute: "хв.",
      second: "сек."
    }
  },
  tip: "Чайові",
  titles: {
    cashback: "Cashback",
    dropsWins: "Drops and wins",
    err404: "Такої сторінки не існує",
    fraud: "Захист від шахрайства",
    gameGroups: {
      "GamesByGroup\/slot": "Слоти онлайн - грати в ігрові автомати на гроші, безкоштовно без реєстрації"
    },
    home: "{titlePure}",
    profile: "Профіль",
    protection: "Захист інформації",
    responsibleGame: "Відповідальна гра",
    rules: "Правила та умови",
    tournaments: "Турніри",
    work: "Ведуться технічні роботи"
  },
  to: "до {date}",
  toFindOutWalletAddressOfCoin: "Чтобы узнать адрес кошелька какой-либо монеты, на основном экране нажмите на монету которую хотите получить, далее отобразится страница монеты с историей транзакций",
  toPromoStart: "До начала акции",
  toSupport: "в службу поддержки",
  topLines: "Топ Линии",
  topUp: "Поповнити",
  topUpWith: "Поповнити з",
  topupYourBalance: "Для игры на деньги, пополните ваш баланс",
  total: "Всього",
  tournament: "Турнір",
  tournamentCryptoReminderText: "Для получения выигрыша не забудьте указать криптокошелёк Doge в личном кабинете ",
  tournamentDescription: "Опис турніру",
  tournamentEnded: "Турнир завершился",
  tournamentGame: "Гра бере участь у турнірі",
  tournamentGames: "Ігри турніру",
  tournamentMounth: {
    "01": "Января",
    "02": "Февраля",
    "03": "Марта",
    "04": "Апреля",
    "05": "Мая",
    "06": "Июня",
    "07": "Июля",
    "08": "Августа",
    "09": "Сентября",
    "10": "Октября",
    "11": "Ноября",
    "12": "Декабря"
  },
  tournaments: "Турниры",
  transactionCopied: "Вы скопировали id транзакции",
  transactionSuccess: "Транзакція успішно завершена",
  transactionsIsNotExist: "У вас пока не было транзакций",
  transactionsNotFound: "Транзакций по выбранным фильтрам не найдено. Попробуйте отредактировать параметры фильтра или {0}",
  transfer: "Перевести",
  transferAccount: "Перевести на рахунок",
  transferAmount: "Введіть суму переказу",
  transferAmount2: "Введіть суму переказу",
  transferSuccessfully: "Переказ коштів успішно завершено!",
  transferTheMoneyAndWait: "Передайте деньги кассиру и ожидайте пополнения",
  transitionDate: "Дата транзакции",
  transitionStatus: "Статус транзакции",
  transitionType: "Дата транзакции",
  turnOff: "Выключить",
  turnOn: "Включить",
  turnOnState: "Включено",
  turnover: "Оборот",
  twoFactorAuth: "Двухфакторная аутентификация",
  typeOfTransaction: "Тип транзакции",
  uncalculated: "Нерассчитанные",
  underCoinBalanceClickGetButton: "Под балансом монеты нажимаем кнопку «Получить».  Далее необходимо скопировать адрес при помощи кнопки или использовать штрихкод для сканирования",
  unexpectedErrorWriteToSupport: "Произошла непредвиденная ошибка, но мы уже скоро все поправим.",
  unexpected_error_try_again: "Непередбачена помилка, спробуйте ще раз",
  unhandledErrorTryToRefreshPage: "Несподівана помилка, спробуйте оновити сторінку",
  unselect: "Снять выделение",
  untilStartLeft: "До початку залишилося",
  update: "Оновити",
  upload: "Загрузить",
  uzbek: "Узбецька",
  verification: "Верификация",
  verificationDeclined: "Верифікацію відхилено. Будь ласка, зв'яжіться зі службою підтримки.",
  verificationDeclinedInfo: "Документи не пройшли перевірку. Будь ласка, прикріпіть документи повторно або зв'яжіться зі службою підтримки.",
  verificationInProgress: "Верифікація виконується. Будь ласка, зачекайте.",
  verificationsSMSDesc: "Для верифікації платежів, підтвердіть номер телефона, який ви вказували при реєстрації",
  verifyYourAccount: "Підтвердіть ваш аккаунт",
  virtuals: "В-Спорт",
  wager: "Вейджер",
  wagerGame: {
    accessAfterRolePlay: "Гра буде доступна після закінчення відіграшу бонусу",
    gamesWagering: "Ігри в яких доступний відіграш",
    nowPlayed: "Зараз відіграно",
    remainForPlay: "Залишилося відіграти"
  },
  wallet: "Кошелек",
  walletCopied: "Кошелек скопирован",
  walletId: "Адрес кошелька",
  walletNotLinked: "Кошелек не привязан",
  way: "Метод виведення",
  ways: "Методи виведення",
  wbCashboxActiveText: "Для отримання 100% за депозит на бонусний рахунок поповніть рахунок від {minSum}. Основний рахунок буде доступним після відіграшу бонусу.",
  wbCashboxNotActiveText: "Для отримання 100% за депозит на бонусний рахунок активуйте бонус в особистому кабінеті.",
  wbWaitOnProfile: "Вітальний бонус чекає вас в розділі «Бонуси» в особистому кабінеті",
  welcomeBonus: "Welcome бонус",
  welcomeBonusCasino: "Welcome бонус казино",
  welcomeBonusDescription: "Встигніть внести оплату впродовж години та отримайте збільшений бонус<span class='text-accent'>125%</span> за депозит і до 250 фріспінів!\n ",
  welcomeBonusSport: "Welcome бонус спорт",
  welcomeBonusTitle: "+25% до Welcome бонусу",
  win: "Перемога",
  winnerPoints: "Очки переможців",
  winners: "Выигравшие",
  withAnIncrease: "При повышении",
  withDrawOrdered: "Вывод оформлен",
  withDrawOrderedDesc: "В ближайшее время средства будут зачислены на ваш указанный счет.",
  withInstantCashback: "С моментальным кэшбэком",
  withdraw: "Вивести",
  withdraw2: "Вивести на",
  withdrawBK: "Вивести на БК",
  withdrawFunds: "Виведення коштів",
  withdrawMethod: "Спосіб виведення",
  withdrawMethods: "Способи виведення",
  withdrawNoun: "Виведення",
  withdrawPaymentInfo: "Зняття коштів за допомогою Visa/Mastercard доступне лише на прив'язані до логіну карти. Для прив'язки Вам необхідно поповнити Ваш логін методом Visa/Mastercard.",
  withdrawPerDayCountExceeded: "Ви можете зробити до 1 виведення щодня",
  withdrawTelegramBot: "Для виведення коштів необхідно запустити Телеграм-бот і авторизуватися в ньому",
  withdrawWithApprove: "Вывод средств с подтверждением кода",
  withdrawWithCode: "Виведення коштів із підтвердженням кодом",
  withdrawal: "Обмеження на виведення коштів",
  withdrawalCompletedSuccessfully: "Заказ на вывод сформирован",
  withdrawalOfFunds: "Виведення коштів із підтвердженням кодом",
  work: "Ведуться технічні роботи",
  writeToSupport: "Написать в поддержку",
  yes: "Так",
  yesConfirm: "Да, уверен",
  yesOfCourseIWant: "Так, звичайно хочу",
  yesRefundWithdrawal: "Да, отменить вывод",
  yesSure: "Да, пополнил",
  you: "Вы",
  youAreAuthorized: "Ви авторизовані",
  youAreParticipateInTheTournament: "Вы участвуете в турнире!",
  youDontHaveTransactions: "У вас пока не было транзакций",
  youHaveNewMessage: "У вас нове повідомлення",
  youHaveNotNewMessages: "У вас немає нових повідомлень",
  youHaveSmsVerification: "У вас включена верифікація платежів, для здійснення переказу, пройдіть перевірку по SMS",
  youTakePart: "Ви берете участь",
  yourBalance: "Ваш баланс",
  yourCasinoBonus: "Ваш бонус у казино",
  yourCurrentEmail: "Ваш e-mail сейчас",
  yourCurrentPhone: "Ваш номер сейчас",
  yourEmail: "Ваш email",
  yourPersonalUniqueWalletIsDisplayedHere: "Здесь отображен ваш личный уникальный кошелек для той монеты, которую вы выбрали ранее. Для копирования адреса кошелька можно использовать специальную кнопку или QR код."
} 
